import React from 'react';
import { cn } from '@/lib/utils';

export const getRiskColor = (risk) => {
  switch (risk) {
    case 'Baixo risco':
      return 'bg-[#E8F5E9] text-[#2E7D32] border-[#2E7D32]/20';
    case 'Médio risco':
      return 'bg-[#FFF8E1] text-[#F57F17] border-[#F57F17]/20';
    case 'Alto risco':
      return 'bg-[#FFEBEE] text-[#C62828] border-[#C62828]/20';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export const getRiskIcon = (risk) => {
  switch (risk) {
    case 'Baixo risco':
      return '🟢';
    case 'Médio risco':
      return '🟡';
    case 'Alto risco':
      return '🔴';
    default:
      return '⚪';
  }
};

export const RiskBadge = ({ risk, className }) => {
  return (
    <span
      data-testid="risk-badge"
      className={cn(
        'inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider border',
        getRiskColor(risk),
        className
      )}
    >
      <span>{getRiskIcon(risk)}</span>
      {risk}
    </span>
  );
};
